//Events
export const GA_SIMULATION_SAVE = 'SIMULATION_SAVE';
export const GA_STUDY_BTN = 'STUDY_BTN';
//Category Array
export const FINISH_CATEGORY = [GA_SIMULATION_SAVE, GA_STUDY_BTN];
//Category Name
export const FINISH_ACTION = 'finishAction';
